module.exports = __webpack_public_path__ + "img/bmh.0850a32c.png";